// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__FJJxw","img":"style_img__xil17"};